<template>
    <v-container fluid>
        <v-row v-if="message" dense>
            <v-col cols="12">
                <div v-html="message"></div>
            </v-col>
        </v-row>
        <v-row v-for="record in dependencies" :key="record.id" dense>
            <v-col cols="12">
                <span v-if="!single" class="record-dependencies">{{ $t('dependencies_for_xy', record) }}</span>
                <v-expansion-panels
                    v-for="(recordDependencies, entity) in record.dependencies"
                    :key="entity"
                    class="mt-2"
                    accordion
                    :value="0"
                >
                    <v-expansion-panel>
                        <v-expansion-panel-header class="flex-row-reverse" disable-icon-rotate>
                            <template #actions="{ open }">
                                <v-icon v-if="open">ic-20 ic-col-grey ic-delete</v-icon>
                                <v-icon v-else>ic-20 ic-col-grey ic-new</v-icon>
                            </template>
                            <span>{{ $t(`${entity}`) }}</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <AddressDependencyList
                                v-if="
                                    entity === 'address_contact' ||
                                    entity === 'address_main' ||
                                    entity === 'location_address' ||
                                    entity === 'event_organizer_address'
                                "
                                :dependencies="recordDependencies"
                            />
                            <EventDependencyList
                                v-else-if="full && entity === 'event'"
                                :dependencies="recordDependencies"
                            />
                            <CategoryDependencyList
                                v-else-if="entity === 'kategorien'"
                                :dependencies="recordDependencies"
                            />
                            <MailingListDependencyList
                                v-else-if="entity === 'mailing_liste'"
                                :dependencies="recordDependencies"
                            />
                            <TagDependencyList v-else-if="entity === 'tag'" :dependencies="recordDependencies" />
                            <DependencyList v-else :dependencies="recordDependencies" :entity="entity" />
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { getI18nInstance as i18n } from '@/i18n';
import DependencyList from '@/components/DependencyList.vue';
import EventDependencyList from '@/components/event/EventDependencyList.vue';
import AddressDependencyList from './address/AddressDependencyList.vue';
import CategoryDependencyList from './category/CategoryDependencyList.vue';
import MailingListDependencyList from './mailing_list/MailingListDependencyList.vue';
import TagDependencyList from './tag/TagDependencyList.vue';

export default {
    name: 'DependencyView',
    components: {
        DependencyList,
        EventDependencyList,
        AddressDependencyList,
        CategoryDependencyList,
        MailingListDependencyList,
        TagDependencyList,
    },

    props: {
        message: {
            type: String,
            default: () => i18n().t('records_have_following_dependencies'),
        },
        dependencies: {
            type: Array,
            required: true,
        },
        single: {
            type: Boolean,
            default: false,
        },
        full: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.record-dependencies {
    font-size: 1.2rem;
}
.entity {
    font-weight: bold;
}
</style>
